import styled from "styled-components/macro"

const Favourites = ({ children }) => {
  return <FavouritesWrapper>{children}</FavouritesWrapper>
}

const FavouritesWrapper = styled.div`
  z-index: 100;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 100vh;
  width: 100%;
  background-color: var(--primary);
  overflow: hidden;

  .favourites-container {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    border-left: 1px solid var(--black);
    transition: transform 0.4s ease-in-out;

    .no-favourites {
      font-size: 2em;
      font-weight: 700;
      color: var(--black);
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;

      span {
        font-style: italic;
        text-transform: lowercase;
      }
    }

    .switch {
      display: none;
      button {
        all: unset;
      }

      .SwitchRoot {
        width: 40px;
        height: 22px;
        background-color: #666666;
        border-radius: 9999px;
        position: relative;
        -webkit-tap-highlight-color: transparent;

        &[data-state="checked"] {
          background-color: var(--accent);
        }
      }

      .SwitchThumb {
        display: block;
        width: 19px;
        height: 15px;
        background-color: var(--primary);
        border-radius: 9999px;
        transition: transform 100ms;
        transform: translateX(4px);
        will-change: transform;

        &[data-state="checked"] {
          transform: translateX(17px);
        }
      }

      .Label {
        color: var(--secondary);
        font-size: 15px;
        line-height: 1;
      }
    }

    .favourites-table {
      position: absolute;
      z-index: 2;
      left: 0%;
      width: 25%;
      height: 100%;
      transition: all 0.3s ease;
      display: flex;
      flex-direction: column;
      gap: 1.5em;
      justify-content: center;
      align-items: center;
      padding: 3em;
      font-weight: 700;
      background-color: var(--primary);
      box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.1);

      .table {
        width: 100%;
        height: 60%;
      }

      .switch {
        margin-top: auto;
        margin-left: auto;
      }

      .flex-table-header {
        color: var(--primary);
      }

      .favourites-control-index {
        display: flex;
        justify-content: start;
        align-items: center;
        border-radius: 5px;
        overflow: hidden;
        color: var(--secondary) !important;
        width: 100%;
        border: 1px solid #4141412b;

        .sidebarButtons {
          width: 100%;
          color: var(--secondary);
        }

        .active {
          color: var(--primary);
          background-color: var(--secondary);
        }
      }

      .table-bottom-controls {
        display: flex;
        width: 100%;
        gap: 1em;

        .bottom-controls-button {
          border-radius: 5px;
          padding: 0.5rem 1rem;
        }

        .bottom-controls-button:last-child {
          margin-left: auto;
          border-radius: 5px;
        }

        .clear-favorites {
          display: flex;
          gap: 1em;

          .prompt {
            display: flex;
            gap: 0.3em;
            margin-left: -2em;
            opacity: 0;
            transition: all 0.3s ease-in-out;

            &.active {
              opacity: 1;
              margin-left: 0em;
              transition: all 0.3s ease-in-out;
            }
          }
        }
      }
    }

    .favourites-info {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      background-color: var(--primary);

      .unit-compare-container {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .unit-top {
          border-right: 1px solid var(--accent);
          width: 50%;
          height: 100%;
        }
        .unit-bottom {
          width: 50%;
          height: 100%;
        }
      }
    }
  }
`

export default Favourites
